(function () {
  if (typeof ConstructorioClient === 'undefined' || !window.cnstrc || !window.cnstrc.indexKey) return;
  try {
    window.constructorio = new ConstructorioClient({
      apiKey: window.cnstrc.indexKey,
      userId: window.cnstrc.userId,
      testCells: window.cnstrc.testCell ? { abTest: window.cnstrc.testCell } : {}
    });
  } catch (e) {
    console.error('Constructor.io init failed:', e);
  }
})();
